import { render, staticRenderFns } from "./DuplicateModalBody.vue?vue&type=template&id=8a2c8bce&lang=pug&"
import script from "./DuplicateModalBody.vue?vue&type=script&lang=js&"
export * from "./DuplicateModalBody.vue?vue&type=script&lang=js&"
import style0 from "./DuplicateModalBody.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports